import { Component, OnInit } from "@angular/core";

@Component({
	standalone: false,
	selector: "ay-page-main-content",
	template: "<ng-content></ng-content>",
})
export class AyPageMainContentComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
